import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import NProgress from 'nprogress'

import PlayButton from '../PlayButton';
import ElementShortcuts from '../ElementShortcuts';
import Grid from '../Grid';

import Train from '../../services/train.js';
import StringUtils from '../../services/StringUtils.js';
import NumberUtils from '../../services/NumberUtils.js';
import Notification from '../../services/Notification.js'

import '../../../css/Tag.css';
import '../../../css/elementPage.css';

class Tag extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  fetchData(tagName) {   
    NProgress.start();

    Train.fetchTag({tag: tagName})
    .then((tag) => {
      this.setState({tag, tagName});
      NProgress.done();
    }).catch((e) => {
      NProgress.done();
      Notification.show('Error loading tag data', 'error');
    });
  }

  componentDidMount() {
    let tag = decodeURIComponent(this.props.match.params.tag);
    this.fetchData(tag);
  }

  componentWillReceiveProps(newProps) {
    let tag = decodeURIComponent(newProps.match.params.tag);
    if (tag !== this.state.tagName) {
      this.setState({tag: undefined, tagName: undefined});
      this.fetchData(tag);    
    }
  }

  summary() {
    let summary = this.state.tag.info.summary;
    summary = StringUtils.replaceAll(summary, '<a ', '<a class="clickable" target="_blank"');
    return summary;
  }

  render() {

    let tag = this.state.tag;

    if (!tag) {
      return <div className="elementPage"></div>;
    }

    let imageStyle = {
      backgroundImage: `url(${tag.img})`
    };

    return (
 
      <div className="elementPage">

        <div className="header">

          <div className="profileImage" style={imageStyle} ></div>

          <div className="content">

            <h1>#{this.state.tagName}</h1><PlayButton type={'tag'} element={tag}/>

            <br/>

            <div className="stats">
              <span><b>Reach</b> {NumberUtils.abbreviation(tag.info.reach)}</span>
              <span><b>Taggings</b> {NumberUtils.abbreviation(tag.info.taggings)}</span>
            </div>

            <ElementShortcuts type={'tag'} element={tag}/>

          </div>

        </div>

        <div className="summary">
         { ReactHtmlParser(this.summary()) }
        </div>

        <Grid title="Top artists" carousel={true} type="artist" playable={true} elements={tag.topArtists}/>
        <Grid title="Top tracks" carousel={true} type="track" playable={true}  elements={tag.topTracks}/>
        <Grid title="Top albums" carousel={true} type="album" playable={true}  elements={tag.topAlbums}/>

      </div>
              
    ); 

  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/js/components/tag/Tag.jsx